export const dashboard = '/trainer/dashboard';
export const DATAFLOW_OPERATIONS_TRAINING = 'DATAFLOW OPERATIONS TRAINING';
export const WELCOME_TO_DATAFLOW_TRAINING = 'Welcome to DataFlow Training';
export const WELCOME_LINE = 'Unlock the power of seamless DataFlow Operations!';
export const GO_TO_DASHBOARD = 'Go To Dashboard';
